export const TOP_AREA_BANNER_BENEFIT_BANNER_SKELETON = 'top-area-banner-benefit-banner-skeleton';
